import $ from 'jquery';
// TODO: (@mbenin) look into using es6-promise (lighter)
import P from 'bluebird';

export default function (url, options = {}) {
    return new P(function (resolve, reject) {
        options.success = function (data) {
            resolve(data);
        };

        options.error = function (jqXHR, status, error) {
            reject([jqXHR, status, error]);
        };

        $.ajax(url, options);
    });
}
